const Resources = {

    table_headers: [
        {
            text: 'Name',
            align: 'start',
            value: 'name',
            type:  'link',
            sort_type: 'text',
        },
        {
            text: 'Abbreviation',
            value: 'abbreviation',
            sort_type: 'text',
        },
        {
            text: 'Building',
            value: 'building',
            sort_type: 'text',
        },
        {
            text: 'Area counter',
            value: 'area_counter',
            sort_type: 'number',
        },
        {
            text: 'Room Counter',
            value: 'room_counter',
            type: 'text_link_action',
            sort_type: 'number'
        },
        {
            text: 'Sq. Footage',
            value: 'sq_ft',
            sort_type: 'number',
        },
    ],

    breadcrumb:[
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Buildings",
            href: "/buildings",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Levels",
            href: "/building-levels",
            arrow: "",
        },
    ],

    excel_file_headers: {
        'Building': 'building_id',
        'Name': 'name',
        'Abbreviation': 'abbreviation',
    },

    empty_format_data: [
        {
            building: '',
            building_id: '',
            name: '',
            abbreviation: '',
        },
    ],

    helps: [
        {
            label: '¿How to add a Level?', 
            instruction: `https://scribehow.com/embed/Adding_a_Level__FaFLOrOKS5-PyGQoi4kIXA?as=scrollable`
        },
        {
            label: '¿How to delete Levels?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Levels__aofvOoyLTDKd3JP5utuWEg?as=scrollable`
        },
    ]

}

export default Resources;